import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';
import { ExecutionQTestEssayGroup } from '../model/execution';
import * as _ from 'lodash';
import { DateUtils } from '../utils/dateUtils';

@Injectable({
  providedIn: 'root'
})
export class ExecutionQTestEssayGroupService {

  readonly baseUrl = `${environment.qualificatesUrl}/executionQTestEssayGroup`;
  constructor(private http: HttpClient) {}

    updateEssay(idEssayGroup: number, data: ExecutionQTestEssayGroup): Observable<any> {
      const url = `${this.baseUrl}/${idEssayGroup}`;

      for (let indexValues = 0; indexValues < data.essayValues?.length; indexValues++) {
          const elementValue = data.essayValues[indexValues];
          if (elementValue.fcStartEssay != null) {
              elementValue.fcStartEssay = DateUtils.anyToDate(elementValue.fcStartEssay as Date);
              elementValue.fcStartEssay = new Date(`${elementValue.fcStartEssay.toString().split('GMT')[0]} UTC`).toISOString()
                  .split('.')[0] + '.000+0000';
          }

          if (elementValue.fcEndEssay != null) {
              elementValue.fcEndEssay = DateUtils.anyToDate(elementValue.fcEndEssay as Date);
              elementValue.fcEndEssay = new Date(`${elementValue.fcEndEssay.toString().split('GMT')[0]} UTC`).toISOString()
                  .split('.')[0] + '.000+0000';
          }
          
          if(elementValue.sensors != null){
              elementValue.sensors?.forEach(s => {
                  delete s.data;
              });
            }
      }

      return this.http.put(url, data).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
      
}
